import React, { useState } from 'react'
import NetworkHTMLReport from '../../../Pages/NetworkHTMLReport'
import { certinNetworkDesign, fontPageNetworkBlueImage, reportNetworkDate, reportNetworkName } from './Part1/FrontPage'
import { AlignmentType, BorderStyle, Document, Footer, Header, HeadingLevel, ImageRun, LevelFormat, NumberFormat, Packer, PageNumber, PageOrientation, Paragraph, SectionType, ShadingType, TabStopType, Table, TableCell, TableLayoutType, TableOfContents, TableRow, TextRun, VerticalAlign, WidthType, convertInchesToTwip } from 'docx'
import { saveAs } from 'file-saver'
import homepageImage from '../../../../Assests/ReportImages/isecurion1.png';
import { TOCHeadingsNetwork, documentHeading2Network, documentHeadingNetwork, documentNetworkFirstTable, documentNetworkSecondTable, page2Heading2Network, page2Heading3Network, page2HeadingNetwork, page2NetworkSecondTable, page2NetworkThirdTable, page2NetworkfirstTable } from './Part1/Page1Network'
import { aboutPage1, aboutPage2, aboutPage3, aboutPage4, bulletOne, bulletThree, bulletTwo, bulletfive, bulletfour, bulletsix } from '../../Web/CertInSupport-Page/Part1CertIn/Page4'
import { disclaimerNetworkPage1, disclaimerNetworkPage2, disclaimerNetworkPage3, disclaimerNetworkPage4, disclaimerNetworkPage5 } from './Part1/Page3Network'
import { bulletObjectiveNetwork1, bulletObjective2, bulletObjective3, objectiveNetworkPage1, scopeHeadingNetwork, scopeHeadingNetwork1, scopeNetwork1, scopeTableNetwork } from './Part1/Page4Network'
import { summaryNetwork1, summaryNetwork2, summaryNetwork3, summaryNetwork4, summaryNetwork5 } from './Part1/Page5Network'
import { NetworkNote, acclimatizePhaseText1, acclimatizePhaseText2, acclimatizePhaseText3, acclimatizePhasebullet1, acclimatizePhasebullet2, accrualPhasebullet1Network, accrualPhasebullet2Network, accrualPhasebullet3Network, accrualPhasebullet4Network, accrualPhasebullet5Network, admittancePhaseTextNetwork, affirmationPhaseTextNetwork, setUpAndMethodologyNetwork } from './Part2/Page6Network'
import { acclimatizePhase, accrualPhase, accrualPhaseText } from '../../Web/CertInSupport-Page/Part2CertIn/Page8'
import { admittancePhase, affirmationPhase, analysisPhase, analysisPhaseText } from '../../Web/CertInSupport-Page/Part2CertIn/Page9'
import { frameworkNetwork, frameworkTextNetwork, toolsNetwork, toolsTableNetwork } from './Part2/Page7Network'
import { observationTextNetwork1, severityTableNetwork } from './Part2/Page8Network'
import { severityLevelTableNetwork, summaryTextNetwork1, summarytext2 } from './Part2/Page9Network'
import { piechartText, tableText } from '../../Web/CertInSupport-Page/Part2CertIn/Page12'
import { findingsTextNetwork } from './Part3/Page10Network'
import { handleCertInNetworkAuditDownload } from '../NetworkInternalCertinAuditReport/NetworkAuditReport'
import { useAuth } from '../../../../Context/UserContext'


function NetworkCertinReport() {

  const [certInNetworkClientName, setCertInNetworkClientName] = useState([])
  const [certInNetworkDate, setCertInNetworkDate] = useState('')
  const [certInNetworkCustomerName, setCertInNetworkCustomerName] = useState('')
  const [certInNetworkConsultantName, setCertInNetworkConsultantName] = useState([])
  const [certInNetworkLogo, setCertInNetworkLogo] = useState('')
  const [certInNetworkApplicationIP, setCertInNetworkApplicationIP] = useState('')
  const [certInNetworkStartDate, setCertInNetworkStartDate] = useState('')
  const [certInNetworkEndDate, setCertInNetworkEndDate] = useState('')
  const [certInNetworkTestingype, setCertInNetworkTestingType] = useState('')
  const [certInNetworkAppDescription, setCertInNetworkAppDescription] = useState('')
  const [certInNetworkAppEnvironment, setCertInNetworkAppEnvironment] = useState('')
  const [criticalityNetwork, setCriticalityNetwork] = useState('')

  const [imageUrlNetwork, setImageUrlNetwork] = useState(null);
  const [inchargeNameNetwork, setInchargeNameNetwork] = useState('')
  const [inchargeEmailNetwork, setInchargeEmailNetwork] = useState('')
  const [inchargeDesignationNetwork, setInchargeDesignationNetwork] = useState('')

  const [certInNetworkDownloading, setCertInNetworkownloading] = useState(false)

  const [certInNetworkVulnerabilities, setCertInNetworkVulnerabilities] = useState([
    { vulnerability: '', description: '', ipAddress: '', impact: '', risk: '', recommendation: '', reference: '', poc: [{ pocDesc: '', files: [] }] }
  ])

  const [certInNetworkVulCount, setCertInNetworkVulCount] = useState('')
  const [certInNetworkCritical, setCertInNetworkCritical] = useState('')
  const [certInNetworkHigh, setCertInNetworkHigh] = useState('')
  const [certInNetworkMedium, setCertInNetworkMedium] = useState('')
  const [certInNetworkLow, setCertInNetworkLow] = useState('')

  const {logout} = useAuth()


  const handleCertInNetworkDownload = () => {
    handleCertInNetworkPhase1Download()
    handleCertInNetworkAuditDownload({
      certInNetworkClientName, certInNetworkDate, certInNetworkCustomerName, certInNetworkConsultantName,
      certInNetworkLogo, certInNetworkApplicationIP, certInNetworkStartDate, certInNetworkEndDate,
      certInNetworkTestingype, certInNetworkAppDescription, certInNetworkAppEnvironment, criticalityNetwork,
      inchargeNameNetwork, inchargeEmailNetwork, inchargeDesignationNetwork, certInNetworkVulnerabilities,
      certInNetworkVulCount, certInNetworkCritical, certInNetworkMedium, certInNetworkLow, certInNetworkHigh, setCertInNetworkownloading, logout
    })
  }

  const handleCertInNetworkPhase1Download = async () => {

    const frontpage1 = certinNetworkDesign
    const frontpage2 = fontPageNetworkBlueImage
    const frontpage3 = reportNetworkName(certInNetworkCustomerName)
    const frontpage4 = reportNetworkDate(certInNetworkDate)

    const pageN1 = documentHeadingNetwork
    const pageN11 = documentNetworkFirstTable(certInNetworkCustomerName)
    const pageN12 = documentHeading2Network
    const pageN13 = documentNetworkSecondTable(certInNetworkCustomerName, certInNetworkDate)
    const pageN14 = page2HeadingNetwork
    const pageN15 = page2NetworkfirstTable(certInNetworkDate)
    const pageN16 = page2NetworkSecondTable(certInNetworkClientName)
    const pageN17 = page2Heading3Network
    const pageN18 = page2NetworkThirdTable(certInNetworkConsultantName)

    const page111 = TOCHeadingsNetwork

    const page22 = aboutPage1
    const page23 = aboutPage2
    const page24 = aboutPage3
    const page25 = aboutPage4
    const page251 = bulletOne
    const page252 = bulletTwo
    const page253 = bulletThree
    const page254 = bulletfour
    const page255 = bulletfive
    const page256 = bulletsix

    const page31 = disclaimerNetworkPage1(certInNetworkCustomerName)
    const page32 = disclaimerNetworkPage2
    const page33 = disclaimerNetworkPage3(certInNetworkCustomerName)
    const page34 = disclaimerNetworkPage4
    const page35 = disclaimerNetworkPage5

    const page42 = objectiveNetworkPage1(certInNetworkCustomerName)
    const page421 = bulletObjectiveNetwork1(certInNetworkCustomerName)
    const page422 = bulletObjective2
    const page423 = bulletObjective3(certInNetworkCustomerName)
    const page43 = scopeHeadingNetwork
    const page44 = scopeNetwork1(certInNetworkCustomerName)
    const page45 = scopeHeadingNetwork1
    const page451 = scopeTableNetwork(certInNetworkApplicationIP)

    const page52 = summaryNetwork1(certInNetworkCustomerName, certInNetworkStartDate, certInNetworkEndDate, certInNetworkTestingype)
    const page53 = summaryNetwork2
    const page54 = summaryNetwork3
    const page55 = summaryNetwork4
    const page56 = summaryNetwork5

    const page62 = setUpAndMethodologyNetwork
    const page621 = NetworkNote
    const page63 = accrualPhase
    const page631 = accrualPhaseText
    const page632 = accrualPhasebullet1Network
    const page633 = accrualPhasebullet2Network
    const page634 = accrualPhasebullet3Network
    const page635 = accrualPhasebullet4Network
    const page636 = accrualPhasebullet5Network
    const page64 = acclimatizePhase
    const page641 = acclimatizePhaseText1
    const page642 = acclimatizePhaseText2
    const page643 = acclimatizePhaseText3
    const page644 = acclimatizePhasebullet1
    const page645 = acclimatizePhasebullet2
    const page65 = analysisPhase
    const page651 = analysisPhaseText
    const page66 = admittancePhase
    const page661 = admittancePhaseTextNetwork
    const page67 = affirmationPhase
    const page671 = affirmationPhaseTextNetwork

    const page72 = frameworkNetwork
    const page721 = frameworkTextNetwork(certInNetworkCustomerName)
    const page73 = toolsNetwork
    const page731 = toolsTableNetwork

    const page82 = observationTextNetwork1(certInNetworkCustomerName)
    const page83 = severityTableNetwork

    const page92 = summaryTextNetwork1(certInNetworkVulCount)
    const page921 = summarytext2
    const page93 = tableText
    const page931 = severityLevelTableNetwork(certInNetworkCritical, certInNetworkHigh, certInNetworkMedium, certInNetworkLow)
    const page932 = piechartText

    const page102 = findingsTextNetwork


    const imageData = await fetch(homepageImage).then(response => response.blob());

    const footerIsecurion = new ImageRun({
      type: 'png',
      data: await imageData.arrayBuffer(),
      transformation: {
        width: 225,
        height: 60
      },
    });

    const design = {
      page: {
        margin: { header: 350, footer: 700 },
        size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
        type: SectionType.CONTINUOUS,
      },
    }

    const page21 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "About ISECURION",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page30 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Disclaimer",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page41 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Objectives and Scope",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page51 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Executive Summary",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page61 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Methodology",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page71 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Framework and tools used for Audit",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page81 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Risk Rating Scale",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page91 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Observation Summary",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page101 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 0 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Detailed Findings & Recommendations",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    const page911 = new Paragraph({
      alignment: AlignmentType.LEFT,
      spacing: { before: 50, after: 250, },
      indent: { left: 400 },
      numbering: { reference: "my-crazy-numbering", level: 2 },
      tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
      children: [
        new TextRun({
          text: "Vulnerability to Risk Rating Mapping",
          size: 26,
          color: "C00000",
          font: "Cambria",
          bold: true,
          italics: false,
          allCaps: false
        })
      ],
      heading: HeadingLevel.HEADING_1,
    })

    let clientImageRun;
    const MAX_WIDTH = 610;

    const getBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    const getImageDimensions = (dataUrl) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const aspectRatio = img.width / img.height;
          const width = Math.min(img.width, MAX_WIDTH);
          const height = width / aspectRatio;
          resolve({ width, height });
        };
        img.onerror = (error) => reject(error);
        img.src = dataUrl;
      });
    };

    const createImageRun = async (file) => {
      try {
        const imageData = await getBase64(file);
        const dimensions = await getImageDimensions(imageData);
        return new ImageRun({
          data: imageData,
          transformation: { width: dimensions.width, height: dimensions.height },
        });
      } catch (error) {
        console.error('Error reading image data:', error);
        return null;
      }
    };

    const fetchImageAsBase64 = async (url) => {
      const response = await fetch(url, { mode: 'cors' });
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };

    // finding summary
    const rows = [
      new TableRow({
        children: [
          new TableCell({
            width: { size: 10, type: WidthType.PERCENTAGE },
            children: [
              new Paragraph({
                spacing: { before: 100, after: 100 },
                indent: { left: 30, right: 30 },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "#",
                    font: "Calibri",
                    size: 22,
                    color: "ffffff",
                    bold: true,
                    italics: false
                  })
                ]
              })
            ],
            shading: { type: ShadingType.SOLID, color: "003366" },
            indent: { left: 600 },
            borders: {
              top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
            }
          }),
          new TableCell({
            width: { size: 70, type: WidthType.PERCENTAGE },
            children: [
              new Paragraph({
                spacing: { before: 100, after: 100 },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Vulnerability",
                    font: "Calibri",
                    size: 22,
                    color: "ffffff",
                    bold: true,
                    italics: false
                  })
                ]
              })
            ],
            shading: { type: ShadingType.SOLID, color: "003366" },
            borders: {
              top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
            }
          }),
          new TableCell({
            width: { size: 20, type: WidthType.PERCENTAGE },
            children: [
              new Paragraph({
                spacing: { before: 100, after: 100 },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Risk Rating",
                    font: "Calibri",
                    size: 22,
                    color: "ffffff",
                    bold: true,
                    italics: false
                  })
                ]
              })
            ],
            shading: {
              type: ShadingType.SOLID,
              color: "003366"
            },
            borders: {
              top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
              right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
            }
          }),

        ],
      }),
    ];

    const getSeverityValue = (risk) => {
      switch (risk) {
        case 'Critical': return 1;
        case 'High': return 2;
        case 'Medium': return 3;
        case 'Low': return 4;
        default: return 5;
      }
    };

    const sortVulnerabilities = certInNetworkVulnerabilities ? certInNetworkVulnerabilities.sort((a, b) => getSeverityValue(a.risk) - getSeverityValue(b.risk)): '';
    sortVulnerabilities.forEach((vulnerability, index) => {

      rows.push(
        new TableRow({
          children: [
            new TableCell({
              width: { size: 10, type: WidthType.PERCENTAGE },
              alignment: AlignmentType.CENTER,
              verticalAlign: VerticalAlign.CENTER,
              children: [
                new Paragraph({
                  spacing: { before: 200, after: 200 },
                  alignment: AlignmentType.CENTER,
                  children: [
                    new TextRun({
                      text: `${index + 1}.`,
                      font: "Calibri",
                      size: 22,
                      color: "000000",
                      italics: false
                    })
                  ]
                })
              ],
              shading: { type: ShadingType.SOLID, color: "ffffff" },
              indent: { left: 600 },
              borders: {
                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
              }
            }),
            new TableCell({
              width: { size: 70, type: WidthType.PERCENTAGE },
              alignment: AlignmentType.CENTER,
              verticalAlign: VerticalAlign.CENTER,
              children: [
                new Paragraph({
                  indent: { left: 60 },
                  spacing: { before: 200, after: 200 },
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: vulnerability.vulnerability,
                      font: "Calibri",
                      size: 22,
                      color: "000000",
                      italics: false
                    })
                  ]
                })
              ],
              shading: { type: ShadingType.SOLID, color: "ffffff" },
              borders: {
                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
              }
            }),
            new TableCell({
              width: { size: 20, type: WidthType.PERCENTAGE },
              alignment: AlignmentType.CENTER,
              verticalAlign: VerticalAlign.CENTER,
              children: [
                new Paragraph({
                  spacing: { before: 200, after: 200 },
                  alignment: AlignmentType.CENTER,
                  children: [
                    new TextRun({
                      text: vulnerability.risk,
                      font: "Calibri",
                      size: 22,
                      color: "ffffff",
                      italics: false,
                      bold: true
                    })
                  ]
                })
              ],
              shading: {
                type: ShadingType.SOLID,
                color: vulnerability.risk === "Critical" ? "c00000" : vulnerability.risk === "High" ? "ffc000" : vulnerability.risk === "Medium" ? "00B0F0" : vulnerability.risk === "Low" ? "92D050" : "ffffff"
              },
              borders: {
                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
              }
            }),
          ],
        })
      );
    })

    // vulnerability Table
    const sortedVulnerabilities = certInNetworkVulnerabilities ? certInNetworkVulnerabilities.sort((a, b) => getSeverityValue(a.risk) - getSeverityValue(b.risk)) : '';
    const docSections = sortedVulnerabilities.map(async (vulnerability, index) => {

      const combinedContent = [];

      for (const poc of vulnerability.poc) {
        combinedContent.push(new Paragraph({
          children: [
            new TextRun({
              text: poc.pocDesc,
              size: 24,
              italics: false
            }),
          ],
        }));

        if (poc.files && poc.files.length > 0) {
          for (const file of poc.files) {
            try {
              const imageRun = await createImageRun(file);
              combinedContent.push(new Paragraph({
                spacing: { before: 200, after: 300 },
                children: [imageRun],
              }));
            } catch (error) {
              console.error('Error while uploading POC image:', error);
            }
          }

        } else if (poc.pocImageURL) {
          try {
            const pocImageData = await fetchImageAsBase64(poc.pocImageURL);
            const dimensions = await getImageDimensions(pocImageData);
            const imageRun = new ImageRun({
              data: pocImageData.split(',')[1],
              transformation: { width: dimensions.width, height: dimensions.height },
            });
            combinedContent.push(new Paragraph({
              spacing: { before: 200, after: 600 },
              children: [imageRun],
            }));
          } catch (error) {
            console.error('Error while fetching PoC image from URL:', error);
          }
        }
      }

      return [
        new Paragraph({
          pageBreakBefore: true,
          heading: HeadingLevel.HEADING_1,
          spacing: { before: 150, after: 200 },
          indent: { left: 420, },
          width: { size: 100, type: WidthType.PERCENTAGE },
          numbering: { reference: "my-crazy-numbering", level: 1 },
          children: [
            new TextRun({
              text: vulnerability.vulnerability,
              size: 22,
              color: "c00000",
              font: "Cambria",
              bold: true,
              italics: false
            })
          ],
        }),
        new Table({
          width: { size: 102, type: WidthType.PERCENTAGE },
          alignment: AlignmentType.LEFT,
          borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
          },
          layout: TableLayoutType.FIXED,
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  width: { size: 2035, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },

                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [new TextRun({
                        text: "Vulnerability",
                        font: "Calibri",
                        size: 22,
                        color: "ffffff",
                        bold: true,
                        italics: false
                      })
                      ]
                    })
                  ],
                  shading: { type: ShadingType.SOLID, color: "A7BFDE" },
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
                new TableCell({
                  width: { size: 8000, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      indent: { left: 100, right: 80 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [new TextRun({
                        text: vulnerability.vulnerability,
                        font: "Calibri",
                        size: 22,
                        color: "000000",
                        italics: false
                      })
                      ]
                    })
                  ],

                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
              ]
            }),

            new TableRow({
              children: [
                new TableCell({
                  width: { size: 2035, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [new TextRun({
                        text: "Description",
                        font: "Calibri",
                        size: 22,
                        color: "ffffff",
                        bold: true,
                        italics: false
                      })
                      ]
                    })
                  ],
                  shading: { type: ShadingType.SOLID, color: "A7BFDE" },
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
                new TableCell({
                  width: { size: 8000, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    ...vulnerability.description.split(/(?:•\s*|__)/).filter(Boolean).map(bulletText =>
                      new Paragraph({
                        spacing: { before: 100, after: 100 },
                        alignment: AlignmentType.JUSTIFIED,
                        bullet: { level: 0 },
                        indent: { left: 700, right: 50, top: 50, bottom: 50 },
                        children: [new TextRun({
                          text: bulletText.trim(),
                          font: "Calibri",
                          size: 22,
                          color: "000000",
                          italics: false
                        })
                        ]
                      })
                    )
                  ],

                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
              ]
            }),


            new TableRow({
              children: [
                new TableCell({
                  width: { size: 2035, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [new TextRun({
                        text: "Affected IP       Address ",
                        font: "Calibri",
                        size: 22,
                        color: "ffffff",
                        bold: true,
                        italics: false
                      })
                      ]
                    })
                  ],
                  shading: { type: ShadingType.SOLID, color: "A7BFDE" },
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
                new TableCell({
                  width: { size: 8000, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 50, after: 50 },
                      indent: { left: 100, right: 80 },
                      alignment: AlignmentType.LEFT,

                      children: [
                        new TextRun({
                          text: vulnerability.ipAddress,
                          font: "Calibri",
                          size: 22,
                          color: "000000",
                          italics: false
                        })
                      ]
                    })
                  ],

                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
              ]
            }),

            new TableRow({
              children: [
                new TableCell({
                  width: { size: 2035, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [new TextRun({
                        text: "Risk/Impact",
                        font: "Calibri",
                        size: 22,
                        color: "ffffff",
                        bold: true,
                        italics: false
                      })
                      ]
                    })
                  ],
                  shading: { type: ShadingType.SOLID, color: "A7BFDE" },
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
                new TableCell({
                  width: { size: 8000, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [new Paragraph({
                    spacing: { before: 100, after: 100 },
                    indent: { left: 100, right: 80 },
                    alignment: AlignmentType.LEFT,
                    indent: { left: 100 },
                    children: [new TextRun({
                      text: vulnerability.impact,
                      font: "Calibri",
                      size: 22,
                      color: "000000",
                      italics: false
                    })
                    ]
                  })
                  ],

                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
              ]
            }),

            new TableRow({
              children: [
                // First cell: CVSS Score/ Risk Rating header
                new TableCell({
                  width: { size: 2035, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [
                        new TextRun({
                          text: "Risk Rating",
                          font: "Calibri",
                          size: 22,
                          color: "ffffff",
                          bold: true,
                          italics: false
                        })
                      ]
                    })
                  ],
                  shading: { type: ShadingType.SOLID, color: "A7BFDE" },
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
                // Second cell: Risk score and severity
                new TableCell({
                  width: { size: 8000, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [
                        new TextRun({
                          text: vulnerability.risk,
                          font: "Calibri",
                          size: 22,
                          color: vulnerability.risk === "Critical" ? "c00000" : vulnerability.risk === "High" ? "ffc000" : vulnerability.risk === "Medium" ? "00B0F0" : vulnerability.risk === "Low" ? "92D050" : "ffffff",
                          italics: false,
                          bold: true
                        })
                      ]
                    })
                  ],
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                })
              ]
            }),

            new TableRow({
              children: [
                new TableCell({
                  width: { size: 2035, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [new TextRun({
                        text: "CVE-ID",
                        font: "Calibri",
                        size: 22,
                        color: "ffffff",
                        bold: true,
                        italics: false
                      })
                      ]
                    })
                  ],
                  shading: { type: ShadingType.SOLID, color: "A7BFDE" },
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
                new TableCell({
                  width: { size: 8000, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  spacing: { before: 50, after: 50 },

                  children: [
                    new Paragraph({
                      indent: { left: 100, right: 80 },
                      spacing: { before: 100, after: 100 },
                      children: [
                        new TextRun({
                          text: vulnerability.cveID,
                          font: "Calibri",
                          size: 22,
                          color: "000000",
                          italics: false
                        }),
                      ]
                    }),
                  ],

                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
              ]
            }),

            new TableRow({
              children: [
                new TableCell({
                  width: { size: 2035, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [new TextRun({
                        text: "Recommendation/ Solution",
                        font: "Calibri",
                        size: 22,
                        color: "ffffff",
                        bold: true,
                        italics: false
                      })
                      ]
                    })
                  ],
                  shading: { type: ShadingType.SOLID, color: "A7BFDE" },
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
                new TableCell({
                  width: { size: 8000, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  spacing: { before: 50, after: 50 },

                  children: [
                    new Paragraph({
                      indent: { left: 100, right: 80 },
                      spacing: { before: 100, after: 100 },
                      children: [
                        new TextRun({
                          text: "ISECURION recommends to:",
                          font: "Calibri",
                          size: 22,
                          color: "000000",
                          italics: false
                        }),
                      ]
                    }),
                    ...vulnerability.recommendation.split(/(?:•\s*|__)/).filter(Boolean).map(bulletText =>
                      new Paragraph({
                        indent: { left: 700, right: 80 },
                        spacing: { before: 100, after: 100 },
                        bullet: { level: 0 },
                        children: [
                          new TextRun({
                            text: bulletText.trim(),
                            font: "Calibri",
                            size: 22,
                            color: "000000",
                            italics: false
                          })
                        ]
                      })
                    )

                  ],

                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
              ]
            }),

            new TableRow({
              children: [
                new TableCell({
                  width: { size: 2035, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      spacing: { before: 100, after: 100 },
                      alignment: AlignmentType.LEFT,
                      indent: { left: 100 },
                      children: [new TextRun({
                        text: "Reference",
                        font: "Calibri",
                        size: 22,
                        color: "ffffff",
                        bold: true,
                        italics: false
                      })
                      ]
                    })
                  ],
                  shading: { type: ShadingType.SOLID, color: "A7BFDE" },
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
                new TableCell({
                  width: { size: 8000, type: WidthType.DXA },
                  verticalAlign: VerticalAlign.CENTER,
                  children: [new Paragraph({
                    spacing: { before: 100, after: 100 },
                    alignment: AlignmentType.LEFT,
                    indent: { left: 100, right: 80 },
                    children: [new TextRun({
                      text: vulnerability.reference,
                      font: "Calibri",
                      size: 22,
                      color: "000000",
                      italics: false
                    })
                    ]
                  })
                  ],

                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                  },
                }),
              ]
            }),
          ]
        }),

        new Paragraph({ pageBreakBefore: true }),
        new Paragraph({
          spacing: { after: 200 },
          children: [
            new TextRun({
              text: "Proof of Concept",
              size: 24,
              color: "000000",
              font: "Calibri",
              bold: true,
              italics: false

            })
          ],
        }),

        ...combinedContent
      ]
    })

    const docSectionsResolved = await Promise.all(docSections);

    if (certInNetworkLogo) {
      try {
        const clientImageData = await getBase64(certInNetworkLogo)
        clientImageRun = new ImageRun({
          data: clientImageData,
          transformation: { width: 155, height: 45 }
        })
        console.log("Selected", clientImageRun);
      } catch (error) {
        console.error('Error while uploading client image:', error);
      }
    } else if (imageUrlNetwork) {
      try {
        const clientImageData = await fetchImageAsBase64(imageUrlNetwork);
        clientImageRun = new ImageRun({
          data: clientImageData.split(',')[1],
          transformation: { width: 155, height: 45 }
        });
      } catch (error) {
        console.error('Error while fetching client image from URL:', error);
      }
    }

    const doc = new Document({
      creator: "manjesh",
      numbering: {
        config: [
          {
            reference: "my-crazy-numbering",
            levels: [
              {
                level: 0,
                format: LevelFormat.DECIMAL,
                text: "%1.",
                alignment: AlignmentType.RIGHT,
                style: {
                  paragraph: {
                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                  },
                  run: {
                    size: 26,
                    bold: true,
                    color: "c00000",
                    font: "Cambria"
                  },
                },
              },
              {
                level: 1,
                format: LevelFormat.DECIMAL,
                text: "9.%2",
                alignment: AlignmentType.RIGHT,
                style: {
                  paragraph: {
                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                  },
                  text: { color: "#0f0f3f", bold: true, size: 24, font: "Calibri" },
                  run: {
                    size: 22,
                    bold: true,
                    color: "c00000",
                    font: "Cambria"
                  },
                },
              },
              {
                level: 2,
                format: LevelFormat.DECIMAL,
                text: "8.%3",
                alignment: AlignmentType.RIGHT,
                style: {
                  paragraph: {
                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                  },
                  run: {
                    size: 26,
                    bold: true,
                    color: "c00000",
                    font: "Cambria"
                  },
                },
              },

            ]
          }
        ]
      },
      features: { updateFields: true },
      styles: {
        default: {
          document: {
            run: {
              font: "Calibri",
              bold: false,
              size: 22,
              color: "000000",
            }
          },
          heading2: {
            run: {
              size: 26,
              color: "C00000",
              font: "Cambria",
              bold: true,
              italics: false,
              allCaps: false
            },
            paragraph: { spacing: { line: 276 } },
          },
          heading3: {
            run: {
              font: "Cambria",
              size: 24,
              bold: true,
              color: "0f0f3f",
              italics: false
            },
            paragraph: { spacing: { line: 276 } },
          },
        }
      },
      sections: [
        {
          properties: { page: { margin: { top: 550, right: 0, bottom: -1400, left: 0 }, size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT }, pageNumbers: { start: 0, formatType: NumberFormat.DECIMAL }, } },
          children: [frontpage1, frontpage2, frontpage3, frontpage4,
            // new Paragraph({
            //   children: [
            //     new TextRun({
            //       text:"hi"
            //     })
            //   ]
            // })
          ]
        },
        {
          properties: {
            page: {
              margin: { header: 350, footer: 700 },
              size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
              type: SectionType.CONTINUOUS,
            },
          },
          headers: {
            default: new Header({
              children: [
                new Table({
                  margin: { top: 400 },
                  width: { size: 110, type: WidthType.PERCENTAGE },
                  alignment: AlignmentType.LEFT,
                  borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                  },
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          width: { size: 50, type: WidthType.PERCENTAGE },
                          children: [

                            new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.LEFT, children: [footerIsecurion] })
                          ],
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                          },
                        }),

                        new TableCell({
                          width: { size: 50, type: WidthType.PERCENTAGE },
                          children: [
                            new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.RIGHT, children: [clientImageRun] })
                          ],
                          borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                          },
                        })
                      ]
                    })
                  ]
                })
              ]
            })
          },
          footers: {
            default: new Footer({
              children: [
                new Table({
                  margin: { top: 600 },
                  width: { size: 100, type: WidthType.PERCENTAGE },
                  borders: {
                    top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                  },
                  rows: [
                    new TableRow({
                      children: [

                        new TableCell({
                          width: { size: 65, type: WidthType.PERCENTAGE },
                          children: [
                            new Paragraph({
                              indent: { right: 200 },
                              alignment: AlignmentType.LEFT,
                              children: [
                                new TextRun({
                                  text: "Confidential 2026",
                                  font: "Calibri",
                                  size: 22,
                                  italics: false,
                                }),
                              ],
                            }),
                          ],
                          borders: {
                            top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                          },
                        }),
                        new TableCell({
                          width: { size: 32, type: WidthType.PERCENTAGE },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.RIGHT,
                              children: [
                                new TextRun({
                                  text: "Page",
                                  italics: false,
                                  font: "Calibri",
                                  size: 22,
                                  bold: true,
                                }),
                              ],
                            }),
                          ],
                          borders: {
                            top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                          },
                        }),
                        new TableCell({
                          width: { size: 3, type: WidthType.PERCENTAGE },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.RIGHT,
                              children: [
                                new TextRun({
                                  children: [PageNumber.CURRENT],
                                  italics: false,
                                  font: "Calibri",
                                  size: 22,
                                  bold: true,
                                }),
                              ],
                            }),
                          ],
                          borders: {
                            top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                          },
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
          },
          children: [
            pageN1, pageN11, pageN12, pageN13, pageN14, pageN15, new Paragraph({}), new Paragraph({}), pageN16, pageN17, pageN18
          ],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [
            page111,
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              layout: TableLayoutType.FIXED,
              borders: {
                top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
              },
              alignment: AlignmentType.LEFT,
              rows: [
                new TableRow({

                  children: [
                    new TableCell({
                      width: { size: 100, type: WidthType.PERCENTAGE },
                      children: [
                        new Paragraph({
                          children: [
                            new TableOfContents("Table of Content", {
                              hyperlink: true,
                              headingStyleRange: "1-5",
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
          ],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page21, page22, page23, page24, page25, page251, page252, page253, page254, page255, page256],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page30, page31, page32, page33, page34, page35],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page41, page42, page421, page422, page423, page43, page44, page45, page451],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page51, page52, page53, page54, page55, page56],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page61, page62, page621, page63, page631, page632, page633, page634, page635, page636, page64, page641, page642, page643, page644, page645, page65, page651, page66, page661, page67, page671],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page71, page72, page721, page73, page731],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page81, page82, page83],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page91, page92, page921, new Paragraph({}), page93, page931, new Paragraph({}), page932],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [
            page911,
            new Table({
              width: { size: 100, type: WidthType.PERCENTAGE },
              alignment: AlignmentType.CENTER,
              spacing: { before: 1200 },
              borders: {
                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
              },
              rows: rows
            })
          ],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [page101, page102],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [
            ...docSectionsResolved.flat()
          ],
          pageBreakBefore: true,
        },

        {
          properties: { ...design },
          children: [
            new Paragraph({
              spacing: { before: 3500, after: 150 },
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  text: "End of the Report",
                  size: 26,
                  bold: true,
                  color: "000000",
                  font: "Calibri"
                })
              ]
            })
          ],
          pageBreakBefore: true,
        },


      ]

    })
    Packer.toBlob(doc).then(blob => {
      saveAs(blob, `Security Audit Phase - 1 Network Vulnerability Assessment and Penetration Testing Report of ${certInNetworkCustomerName}`)
    })

  }

  return (
    <div>
      <NetworkHTMLReport
        certInNetworkClientName={certInNetworkClientName}
        setCertInNetworkClientName={setCertInNetworkClientName}
        certInNetworkConsultantName={certInNetworkConsultantName}
        setCertInNetworkConsultantName={setCertInNetworkConsultantName}
        certInNetworkDate={certInNetworkDate}
        setCertInNetworkDate={setCertInNetworkDate}
        certInNetworkCustomerName={certInNetworkCustomerName}
        setCertInNetworkCustomerName={setCertInNetworkCustomerName}
        certInNetworkLogo={certInNetworkLogo}
        setCertInNetworkLogo={setCertInNetworkLogo}
        certInNetworkApplicationIP={certInNetworkApplicationIP}
        setCertInNetworkApplicationIP={setCertInNetworkApplicationIP}
        certInNetworkStartDate={certInNetworkStartDate}
        setCertInNetworkStartDate={setCertInNetworkStartDate}
        certInNetworkEndDate={certInNetworkEndDate}
        setCertInNetworkEndDate={setCertInNetworkEndDate}
        certInNetworkTestingype={certInNetworkTestingype}
        setCertInNetworkTestingType={setCertInNetworkTestingType}
        certInNetworkAppDescription={certInNetworkAppDescription}
        setCertInNetworkAppDescription={setCertInNetworkAppDescription}
        certInNetworkAppEnvironment={certInNetworkAppEnvironment}
        setCertInNetworkAppEnvironment={setCertInNetworkAppEnvironment}
        criticalityNetwork={criticalityNetwork}
        setCriticalityNetwork={setCriticalityNetwork}
        imageUrlNetwork={imageUrlNetwork}
        setImageUrlNetwork={setImageUrlNetwork}
        inchargeNameNetwork={inchargeNameNetwork}
        setInchargeNameNetwork={setInchargeNameNetwork}
        inchargeEmailNetwork={inchargeEmailNetwork}
        setInchargeEmailNetwork={setInchargeEmailNetwork}
        inchargeDesignationNetwork={inchargeDesignationNetwork}
        setInchargeDesignationNetwork={setInchargeDesignationNetwork}
        certInNetworkDownloading={certInNetworkDownloading}
        setCertInNetworkownloading={setCertInNetworkownloading}
        certInNetworkVulnerabilities={certInNetworkVulnerabilities}
        setCertInNetworkVulnerabilities={setCertInNetworkVulnerabilities}
        handleCertInNetworkDownload={handleCertInNetworkDownload}

        certInNetworkVulCount={certInNetworkVulCount}
        setCertInNetworkVulCount={setCertInNetworkVulCount}
        certInNetworkCritical={certInNetworkCritical}
        setCertInNetworkCritical={setCertInNetworkCritical}
        certInNetworkHigh={certInNetworkHigh}
        setCertInNetworkHigh={setCertInNetworkHigh}
        certInNetworkMedium={certInNetworkMedium}
        setCertInNetworkMedium={setCertInNetworkMedium}
        certInNetworkLow={certInNetworkLow}
        setCertInNetworkLow={setCertInNetworkLow}

        handleCertInNetworkPhase1Download={handleCertInNetworkPhase1Download}
      />
    </div>


  )
}

export default NetworkCertinReport
